/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import List, { ListItem } from '../components/List';

interface Props {
  collection: any[];
  onClickItem(item): void;
  itemComponent: any;
  zeroState(count): JSX.Element;
  emptyCollectionMessage?: string;
  listItemStyle?: object;
  helpContent?: any;
}

export const ContentList = (props: Props) => {
  if (props.collection.length === 0) {
    return props.zeroState(props.collection.length);
  }

  return (
    <div>
      {props.zeroState(props.collection.length)}
      {props.helpContent}
      {props.collection.length > 0 &&
        <List hasBorder hasRoundedWrapper paddingSize="default">
          {
            props.collection.map((item, index) => (
              <ListItem
                key={index}
                onClick={() => props.onClickItem(item)}
                style={props.listItemStyle}
              >
                <props.itemComponent {...item} />
              </ListItem>
            ))
          }
        </List>
      }
    </div>
  );
};
